import { types } from "mobx-state-tree"

export default (resultsType)=>(
    types.model({
        count: types.number,
        results: types.array(resultsType),
    })
)


// WEBPACK FOOTER //
// ./src/stores/PaginationResponse.js